import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { postDataLogin } from '../ApiServices/ApiService';
import { Form, Button, Row, Col, Alert, Spinner,Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import LoginNav from './LoginNav';


const ChangePasswordPage = (props) => {
  const location = useLocation();
  const emailTemp = location.state?.email || "";
  const tempPasswords = location.state?.tempPassword || "";
  const [email, setEmail] = useState(emailTemp)
  const [newPassword, setNewPassword] = useState("")
  const [tempPassword, setTempPassword] = useState(tempPasswords)
  const [emailError, setEmailError] = useState("")
  const [passwordError, setPasswordError] = useState("")
  const [passwordNewError, setPasswordNewError] = useState("")
  const [success, setSuccess] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  const [confirmPassword, setConfirmPassword] = useState("")
  const [error, setError] = useState('');

  const navigate = useNavigate();

  // useEffect(() => {
  //   const storedEmail = localStorage.getItem("email_id");
  //   const storedTempPassword = localStorage.getItem("temp_pwd");


  //   setEmail(storedEmail || '');
  //   setTempPassword(storedTempPassword || '');
  // }, []);

  const onButtonClick = async () => {
    setSuccess("")
    setError("")
    setEmailError("")
    setPasswordError("");
    setPasswordNewError("");
    if ("" === email) {
      setEmailError("Please Enter Your Email")
      return
    }

    if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email)) {
      setEmailError("Please Enter A Valid Email")
      return
    }

    if ("" === tempPassword) {
      setPasswordError("Please Enter Temporary Password")
      return
    }

    if ("" === newPassword) {
      setPasswordNewError("Please Enter New Password")
      return
    }

    if (newPassword.length < 7) {
      setPasswordNewError("The Password must be 8 characters or longer")
      return
    }
    if (!/[A-Z]/.test(newPassword)) {
      setPasswordNewError("The Password must have atleast one uppercase")
      return false;
    }
    // Contains at least one lowercase letter
    if (!/[a-z]/.test(newPassword)) {
      setPasswordNewError("The Password must have atleast one lowercase ")
      return false;
    }
    // Contains at least one digit
    if (!/\d/.test(newPassword)) {
      setPasswordNewError("The Password must have atleast one digit ")
      return false;
    }
    // Contains at least one special character
    if (!/[!@#$%^&*()_+{}\[\]:;<>,.?~\\-]/.test(newPassword)) {
      setPasswordNewError("The Password must have atleast one special character ")
      return false;
    }
    if (newPassword !== confirmPassword) {
      setPasswordNewError("New password and Confirm password do not match")
      return false;
    }
    setLoading(true);
    //call the api
    const payload = {
      "op": "ADMIN-CHANGE-PASSWORD",
      "email": email,
      "temp_password": tempPassword,
      "new_password": newPassword,
    }
    try {
      await postDataLogin('/admin/admin_change_pwd', payload).then(resp => {
        if (resp.statusCode === 200) {
          if (resp.message.toLowerCase() === 'success') {
            setLoading(false);
            setSuccess(resp.info);
            setTimeout(() => {
              navigate("/login");              
            }, 3000);
          } else {
            setLoading(false);
            setError(resp.info);
          }

        } else if (resp.statusCode === 500) {
          setLoading(false);
          setError(resp.info);
        } else {
          setLoading(false);
          setError('Change Password failed. Please check your credentials.');
        }
      }).catch((error) => {
        setLoading(false);
        setError('Change Password failed. Please check your credentials or Network Error');
       
      });
    } catch (error) {
      setLoading(false);
      setError('Change Password failed. Please check your credentials or Network Error');
      console.error('Change Password failed', error);
    }




  }


  return (
    <>
      <LoginNav></LoginNav>
      <div className=" outerContainer background-img-2">
        <div className='w-100'style={{marginTop:'0px'}}>
          <h2 className='login-heading' style={{ marginTop: '20px', paddingLeft: '20px' }}>Change/Reset Password</h2>

          <Container className='mainContainer'>
          <div className='formContainer container-width'>
            <Row >
              <Col md={6}>
                {emailError && <Alert variant="danger">{emailError}</Alert>}
                {passwordError && <Alert variant="danger">{passwordError}</Alert>}
                {passwordNewError && <Alert variant="danger">{passwordNewError}</Alert>}
                {success && <Alert variant="success">{success}</Alert>}                
                {error && <Alert variant="danger">{error}</Alert>}
                <Form className="Form">
                  <Form.Group className='input-box margin-bottom'>
                    <Form.Control
                      value={email}
                      placeholder="Enter Your Email Here"
                      onChange={ev => setEmail(ev.target.value)}
                      className={"inputBox placehold-padding"}
                    />
                  </Form.Group>

                  <Form.Group className='input-box margin-bottom'>
                    <Form.Control
                      value={tempPassword}
                      placeholder="Enter Your Temp Password Here"
                      onChange={ev => setTempPassword(ev.target.value)}
                      className={"inputBox placehold-padding"}
                    />
                  </Form.Group>

                  <Form.Group className="input-box margin-bottom">
                    <div className="input-box-wrap">
                      <Form.Control
                        type={showPassword ? 'text' : 'password'}
                        value={newPassword}
                        placeholder="Enter Your New Password Here"
                        onChange={ev => setNewPassword(ev.target.value)}
                        className='input-box-style placehold-padding'
                        style={{ border: 'none' }}
                      />
                      <div className="eye-icon" onClick={() => setShowPassword(!showPassword)}>
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </div>
                    </div>
                  </Form.Group>
                  <Form.Group className="input-box margin-bottom">
                    <div className="input-box-wrap">
                      <Form.Control
                        type={showConfirmPassword ? 'text' : 'password'}
                        value={confirmPassword}
                        placeholder="Enter Your Confirmed Password Here"
                        onChange={ev => setConfirmPassword(ev.target.value)}
                        className='input-box-style placehold-padding'
                        style={{ border: 'none' }}
                      />
                      <div className="eye-icon" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                        {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                      </div>
                    </div>
                  </Form.Group>
                  <div className="margin-bottom" style={{ marginTop: '0px' }}>
                    <span> <span style={{ color: 'red', fontSize: '13px' }}>Note:</span> <span style={{ color: '#333', fontSize: '13px', paddingBottom: '0px' }}>Password should be like Password@123 and 8 characters.</span> </span>
                  </div>
                  <Button variant="dark"
                    className="Button"
                    type="button"
                    onClick={onButtonClick}
                    value={"Submit"}>
                    Submit
                  </Button>
                  {loading && (
                    <div className="spinner-overlay">
                      <Spinner animation="border" role="status">
                        <span className="sr-only"></span>
                      </Spinner>
                    </div>
                  )}
                </Form>
              </Col>
              <Col md={6} className='background-img'></Col>
            </Row>
            
          </div>
          </Container>
        </div>
      </div>
    </>

  );
}

export default ChangePasswordPage;